/* ========== 対象処理 ========== */
// 会員情報更新
// 1. 会員情報表示
// 2. 入力内容確認欄表示
// 3. 会員更新
// 4. パスワード更新
// 5. メールアドレス更新用メール送信
// 6. メールアドレス更新
// 7. 電話番号更新

document.addEventListener("DOMContentLoaded", function () {
  const editAccountArea = document.getElementById('edit_account_area');
  const confirmAccountButton = document.getElementById('confirm_account_button');
  const editAccountButton = document.getElementById('edit_account_button');
  const editPasswordButton = document.getElementById('edit_password_button');
  const deleteAccountButton = document.getElementById('delete_account_button');
  const sendEditEmailButton = document.getElementById('send_email_button');
  const accountEditArea = document.getElementById('account_edit_complete_area');
  const editPhoneButton = document.getElementById('edit_phone_button');
  const modalClose = document.querySelector('.js-modal-close');
  const jsIdEditComplete = document.getElementById('js-id_edit_complete');
  const authCode = document.getElementsByName('auth_code');

  // 会員情報編集ページ
  if (editAccountArea) {
    // inputに会員情報設定
    setCustomer();
    let furigana = document.querySelector('.furigana');
    changeLang(furigana);

    // 確認ボタン
    const confirm_account_form = document.getElementById("confirm_account_form");
    if(confirmAccountButton){
      //郵便番号バリデーション
      setAddress();

      confirm_account_form.addEventListener("submit", (e) => {
        e.preventDefault();
        confirmEditCustomer();
      });
    }

    // 更新ボタン
    editAccountButton.addEventListener("click", async () => {
      editCustomer(editAccountButton);
    });

    // 退会処理
    if (deleteAccountButton) {
      deleteAccountButton.addEventListener("click", async () => {
        deleteCustomer(deleteAccountButton);
      });
    }
  }

  //会員情報登録完了ページ
  if(accountEditArea){
    accountEditComplete(accountEditArea);
  }

  // パスワード更新ボタン
  const password_edit_form = document.getElementById("password_edit_form");
  if (editPasswordButton) {
    checkLogin();
    password_edit_form.addEventListener("submit", async (e) => {
      e.preventDefault();
      editPassword(editPasswordButton);
    });
  }

  // メールアドレス更新用メールフォーム
  const mailaddres_form = document.getElementById("mailaddres_form");
  if (sendEditEmailButton) {
    checkLogin();
    mailaddres_form.addEventListener("submit", (e) => {
      e.preventDefault();
      sendEditEmailMail(sendEditEmailButton);
    });
  }

  // メールアドレス更新
  if (jsIdEditComplete) {
    editEmail(jsIdEditComplete);
  }

  // 電話番号更新ボタン
  if (editPhoneButton) {
    checkLogin();
    editPhoneButton.addEventListener("click", () => {
      editPhone(editPhoneButton);
    });
  }

  //モーダルクローズボタン
  if(modalClose){
    modalClose.addEventListener("click", () => {
      closeModal();
    });
  }

  //認証番号入力イベント
  if(authCode){
    authCode.forEach(function(code){
      code.addEventListener('input', function(){
        checkField(this);
      })
      code.addEventListener('keyup', function(){
        nextField(this);
      })

    })
  }

});


// 会員情報編集ページ表示
const setCustomer = async () => {
  const customer = await getCustomer();

  if (!customer) {
    return;
  }

  setCustomerFields(customer);
};

// 編集内容確認
const confirmEditCustomer = async () => {
  let errorMessage = document.getElementById('error_message');
  errorMessage.innerText = '';

  const params = validateEditCustomer();
  if (!params) {
    errorMessage.innerText = '入力内容に不備があります';
    errorMessage.style.display = "block";
    return;
  }else{
    errorMessage.style.display = "none";
  }

  setNextField();
  setEditCustomerFields(params);
};

// 会員退会処理
const deleteCustomer = async (deleteAccountButton) => {
  const url = `${APP_PROXY_URL}/api/customer`;
  let errorMessage = document.getElementById('error_message');
  let agreeCheckbox = document.getElementById('agreeCheckbox').checked;

  errorMessage.innerText = '';
  btnLoading(deleteAccountButton);

  let params = validateEditCustomer(true);
  if (!params) {
    btnStopLoading(deleteAccountButton);
    return;
  }

  if (!agreeCheckbox) {
    errorMessage.innerText = '注意事項に同意してください';
    errorMessage.style.display = "block";
    btnStopLoading(deleteAccountButton);
    return;
  }
  else {
    params['processFlag'] = 'D';
    params['agreeFlag'] = '1';
  }

  const res = await fetchPutMethod(url, params);
  if (res.message === 'ok') {
    
    const logoutRes = await fetch('/account/logout');
    if (logoutRes.ok) {
      console.log('ログアウト完了');
    }

    window.location.href = `https://${location.hostname}/pages/account_withdraw_complete`;
  } else {
    if (res.error){
      res.message = 'サーバーエラーが発生しました。';
    }
    if (res.errors){
      setServerValidationError(res.errors);
    }

    setBackField(res.message);
    btnStopLoading(deleteAccountButton);
  }
};


// 会員更新処理
const editCustomer = async (editAccountButton) => {
  const url = `${APP_PROXY_URL}/api/customer`;
  let successMessage = document.getElementById('success_message');
  let errorMessage = document.getElementById('error_message');
  successMessage.innerText = '';
  errorMessage.innerText = '';
  btnLoading(editAccountButton);

  const params = validateEditCustomer();
  if (!params) {
    btnStopLoading(editAccountButton);
    return;
  }

  const res = await fetchPutMethod(url, params);
  if (res.message === 'ok') {
    const token = random();
    window.location.href = `https://${location.hostname}/pages/account_edit_complete?token=${token}`;
  } else {
    if (res.error){
      res.message = 'サーバーエラーが発生しました。';
    }
    if (res.errors){
      setServerValidationError(res.errors);
    }

    setBackField(res.message);
    btnStopLoading(editAccountButton);
  }
};

// 変更受付完了表示
const accountEditComplete = async (accountEditArea) => {
  let errorMessage = document.getElementById('error_message');

  const link = new URL(window.location.href);
  const token = link.searchParams.get('token');

  if (!token) {
    for(i = 0; i < accountEditArea.childElementCount; i++){
      accountEditArea.children[i].style.display = 'none';
    }

    errorMessage.innerText = 'セッションがタイムアウトした、もしくは不正な画面遷移が行われた可能性があります。お手数ですが、最初から操作をやり直してください。';
    errorMessage.style.display = "block";
    return;
  }
};

// パスワード更新処理
const editPassword = async (editPasswordButton) => {
  const url = `${APP_PROXY_URL}/api/customer/password`;
  let successMessage = document.getElementById('success_message');
  let errorMessage = document.getElementById('error_message');
  let modalComplete = document.querySelector('.modal-complete');
  let body = document.querySelector('body');

  successMessage.innerText = '';
  errorMessage.innerText = '';
  errorMessage.style.display = 'none';
  btnLoading(editPasswordButton);

  const params = validateEditPassword();
  if (!params) {
    btnStopLoading(editPasswordButton);
    return;
  }

  const res = await fetchPutMethod(url, params);
  if (res.message == 'ok') {
    modalComplete.classList.add('activemodal');
    modalComplete.focus()
    trapFocus(modalComplete)
    body.classList.add('modal-open');
  } else {
    if(res.message == undefined){
      errorMessage.innerText = 'サーバーエラーが発生しました';
    }else{
      errorMessage.innerText = res.message;
    }
    errorMessage.style.display = 'block';
  }
  btnStopLoading(editPasswordButton);
};

//パスワード変更完了モーダルクローズ
const closeModal = async () => {
  let modalComplete = document.querySelector('.modal-complete');
  removeTrapFocus(modalComplete)
  let body = document.querySelector('body');
  modalComplete.classList.remove('activemodal');
  body.classList.remove('modal-open');
};

// メールアドレス更新用メール送信処理
const sendEditEmailMail = async (sendEditEmailButton) => {
  const url = `${APP_PROXY_URL}/api/customer/email`;
  let successSend = document.getElementById('success_send_message');
  let errorMessage = document.getElementById('error_send_message');
  successSend.innerText = '';
  errorMessage.innerText = '';
  errorMessage.style.display = 'none';

  btnLoading(sendEditEmailButton);
  const params = validateEditEmail();

  if (!params) {
    btnStopLoading(sendEditEmailButton);
    return;
  }

  const res = await fetchPutMethod(url, params);
  if (res.message == 'ok') {
    const token = random();
    window.location.href = `https://${location.hostname}/pages/id_edit_mail?token=${token}`;
  } else {
    if(res.message == undefined){
      errorMessage.innerText = 'サーバーエラーが発生しました';
    }else{
      errorMessage.innerText = res.message;
    }
    errorMessage.style.display = 'block';
    btnStopLoading(sendEditEmailButton);
  }
};

// メールアドレス更新処理
const editEmail = async (jsIdEditComplete) => {
  const url = new URL(`${APP_PROXY_URL}/api/customer/email/complete`);
  let errorMessage = document.getElementById('error_message');

  const link = new URL(window.location.href);
  const token = link.searchParams.get('token');
  if (!token) {
    for(i = 0; i < jsIdEditComplete.childElementCount; i++){
      jsIdEditComplete.children[i].style.display = 'none';
    }

    errorMessage.innerText = 'セッションがタイムアウトした、もしくは不正な画面遷移が行われた可能性があります。お手数ですが、最初から操作をやり直してください。';
    errorMessage.style.display = "block";
    return;
  }

  url.searchParams.set('token', token);

  const res = await fetchGetMethod(url.href);
  if (res.message != 'ok') {
    for(i = 0; i < jsIdEditComplete.childElementCount; i++){
      jsIdEditComplete.children[i].style.display = 'none';
    }
    errorMessage.innerText = res.message;
    errorMessage.style.display = "block";
    return;
  }
};


// 電話番号更新処理
const editPhone = async (editPhoneButton) => {
  const url = `${APP_PROXY_URL}/api/customer/phone`;
  let successSend = document.getElementById('success_message');
  let errorMessage = document.getElementById('error_message');
  successSend.innerText = '';
  errorMessage.innerText = '';
  errorMessage.style.display = 'none';
  btnLoading(editPhoneButton);

  const params = validatePhone();
  if (!params) {
    btnStopLoading(editPhoneButton);
    return;
  }

  const res = await fetchPutMethod(url, params);
  if (res.message == 'ok') {
    const token = random();
    window.location.href = `https://${location.hostname}/pages/phone_edit_complete?token=${token}`;
  } else {
    if(res.detailCode == 409004){
      const phoneNumber = document.querySelector('input[name=phoneNumber]');
      displayErrorMessage(phoneNumber, res.message);
    }else{
      errorMessage.innerText = res.message;
      errorMessage.style.display = 'block';
    }
    btnStopLoading(editPhoneButton);
  }
};


/**
* 会員情報編集ページに現会員情報表示
*
* @param {*} customer
*/
const setCustomerFields = (customer) => {
  let lastName = document.querySelector('._name input[name=lastName]');
  let firstName = document.querySelector('._name input[name=firstName]');
  let lastKana = document.querySelector('._name input[name=lastKana]');
  let firstKana = document.querySelector('._name input[name=firstKana]');
  let country = document.querySelector('.c-select select.country');
  let postalCode = document.querySelector('._postcode input[name=postalCode]');
  let prefecture = document.querySelector('.c-select select.prefectures');
  let countyCityAddress = document.querySelector('input[name=countyCityAddress]');
  let townAddress = document.querySelector('input[name=townAddress]');
  let buildingName = document.querySelector('input[name=buildingName]');
  let birthday = document.querySelector('._birthday');
  let itemMailMagazine = document.querySelector('.f-newsletter input[name=itemMailMagazine]');
  let ecMailMagazine = document.querySelector('.f-newsletter input[name=ecMailMagazine]');
  let shopMailMagazine = document.querySelector('.f-newsletter input[name=shopMailMagazine]');
  let confirmBirthday = document.querySelector('.main_info ._birthday');
  let letterFlg = customer.itemMailMagazine == '1' || customer.ecMailMagazine == '1' || customer.shopMailMagazine == '1';

  lastName.value = customer.lastName;
  firstName.value = customer.firstName;
  lastKana.value = customer.lastKana;
  firstKana.value = customer.firstKana;
  country.value = customer.country;

  if (customer.country == 'JP') {
    postalCode.value = customer.postalCode;
    prefecture.value = customer.prefecture;
  } else {
    setEditAddress();
  }

  countyCityAddress.value = customer.countyCityAddress;
  townAddress.value = customer.townAddress;
  buildingName.value = customer.buildingName;
  birthday.innerText = setBirthday(customer);
  itemMailMagazine.checked = customer.itemMailMagazine == '1';
  ecMailMagazine.checked = customer.ecMailMagazine == '1';
  shopMailMagazine.checked = customer.shopMailMagazine == '1';
  confirmBirthday.innerText = `${customer.birthYear}年 ${customer.birthMonth}月 ${customer.birthDay}日`;

  // 性別
  setEditSex(customer.sex);

  // ニュースレター
  setEditNewsletter(letterFlg);

  // DMを受け取る
  setEditDM(customer.shopDM);

  // 関心あるブランド
  if (customer.brandinterestlist !== null && customer.brandinterestlist.length > 0) {
    setEditBlandList(customer.brandinterestlist);
  }
};

// 登録内容ページ設定
const setEditCustomerFields = (customer) => {
  let mainInfo = document.querySelectorAll('.main_info ._customerData');
  let lang = WOVN.io.getCurrentLang().code;

  mainInfo[0].innerText = `${customer.lastName} ${customer.firstName}`;
  let furigana = document.querySelector('.main_info .furigana');
  if(lang == 'ja'){
    mainInfo[1].innerText = `${customer.lastKana} ${customer.firstKana}`;
    furigana.style.display = 'flex';
  }else{
    furigana.style.display = 'none';
  }
  mainInfo[2].innerText = setCountry(customer);
  let postcode = document.querySelector('.main_info .f-postcode');
  let prefectures = document.querySelector('.main_info .f-prefectures');
  if (customer.country == 'JP') {
    mainInfo[3].innerText = customer.postalCode;
    mainInfo[4].innerText = customer.prefecture;
    postcode.style.display = 'flex';
    prefectures.style.display = 'flex';
  } else {
    postcode.style.display = 'none';
    prefectures.style.display = 'none';
  }
  mainInfo[5].innerText = customer.countyCityAddress;
  mainInfo[6].innerText = customer.townAddress;
  mainInfo[7].innerText = customer.buildingName;
  mainInfo[8].innerText = setSex(customer);
  setNewsletter(customer, mainInfo[10]);
  mainInfo[11].innerText = setShopDM(customer);
  setBlandList(customer, mainInfo[12]);
};

const setAddress = () => {
  var isJapanPostalCodeLoaded = false;

    if(!isJapanPostalCodeLoaded){
      // ZipCode AutoFill
      if (typeof JapanPostalCode !== 'undefined') {
        const options = {
          name: 'register',
          messages: {
            addressExists: "住所が正しくありません",
            addressTownExists: "郵便番号に基づいた住所をご登録ください。ご入力いただいた住所の表記を再度ご確認ください。例）〇 三番町 × 3番町",
          }
        };

        // Add New Address
        new JapanPostalCode(
          {
            container: '#edit_account_area',
            form: '#confirm_account_form',
            buttonSubmit: '#confirm_account_button',
            country: '[name="country"]',
            zipCode: '[name="postalCode"]',
            city: '[name="countyCityAddress"]',
            province: '[name="province"]',
            address01: '[name="townAddress"]',
            address02: '[name="buildingName"]',
            firstName: '[name="firstName"]',
            lastName: '[name="lastName"]',
            firstNameKana: '[name="firstKana"]',
            lastNameKana: '[name="lastKana"]',
            phone: '[name="phoneNumber"]',
          },
          options
        );
      }

      isJapanPostalCodeLoaded = true;
    }
}
//ログイン情報が取得できるか確認
const checkLogin = async () => {
  const customer = await getCustomer();

  if (customer === null) {
    return;
  }
};